// hooks/useIOSInstallPrompt.ts
import { useState, useEffect } from 'react';
import { useIsPWA } from './useIsPWA';

const DONT_SHOW_AGAIN_KEY = 'ios-install-prompt-dismissed';

export const useIOSInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const isPWA = useIsPWA();

  useEffect(() => {
    // No mostrar si ya es PWA
    if (isPWA) {
      setShowPrompt(false);
      return;
    }

    // No mostrar si el usuario ya dijo que no
    const dismissed = localStorage.getItem(DONT_SHOW_AGAIN_KEY);
    if (dismissed === 'true') {
      setShowPrompt(false);
      return;
    }

    // Detectar si es iOS Safari
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isInStandaloneMode = window.navigator.standalone;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

    // Mostrar solo en iOS Safari que NO esté en modo standalone
    if (isIOS && isSafari && !isInStandaloneMode) {
      // Esperar un poco antes de mostrar para mejor UX
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 3000); // Mostrar después de 3 segundos

      return () => clearTimeout(timer);
    }
  }, [isPWA]);

  const hidePrompt = () => {
    setShowPrompt(false);
  };

  const dontShowAgain = () => {
    localStorage.setItem(DONT_SHOW_AGAIN_KEY, 'true');
    setShowPrompt(false);
  };

  return {
    showPrompt,
    hidePrompt,
    dontShowAgain
  };
};